import { Ng2StateDeclaration, Transition } from '@uirouter/angular';
import { FiAppearanceStartPageEditComponent } from '@fi-app/appearance/start-page/edit/edit.component';
import { ObjectTypes } from '@fi-shared/types/object-type';
import { ModuleType } from '@fi-shared/types/module-type';
import { WidgetService } from '@fi-app/widget/widget.service';
import { WidgetAdministrateService } from '@fi-app/widget/widget-administrate.service';
import { PageTitleService } from '@fi-app/utilities/fi-services/page-title.service';
import { WidgetModel } from '@fi-app/widget/model/widget.model';
import { FiStateNames } from '@fi-shared/fi-state-proxy/fi-state-names';
import { FiStateService } from '@fi-shared/fi-state-proxy/fi-state.proxy.service';
import { coerceNumberProperty } from '@angular/cdk/coercion';
import { isDefined } from '@fi-shared/utils';
import { FiUserDataService } from '@fi-shared/fi-shared-services/fi-user-data.service';

export const FiAppearanceResolve_SiteDesignId = [
    FiStateService,
    Transition,
    FiUserDataService,
    FiAppearanceResolve_SiteDesignIdFn,
];

export const FiAppearanceStartPageEditState: Ng2StateDeclaration = {
    name: FiStateNames.Appearance.StartPage,
    url: '/StartPage/Edit?{:siteDesignId}',
    views: {
        '@': {
            component: FiAppearanceStartPageEditComponent,
        },
    },
    resolve: {
        siteDesignId: FiAppearanceResolve_SiteDesignId,
        widgets: [WidgetService, FiAppearanceStartPageEditStateResolveWidgets],
        widgetAdministrate: [
            'widgets',
            'siteDesignId',
            WidgetAdministrateService,
            FiAppearanceStartPageEditStateResolveWidgetAdministrate,
        ],
        widgetAdministrateWidgets: [
            'widgets',
            'widgetAdministrate',
            WidgetAdministrateService,
            FiAppearanceStartPageEditStateResoleWidgetAdministrateWidgets,
        ],
        editStartPageModel: [FiUserDataService, FiAppearanceStartPageEditStateResoleEditStartPageModel],
        pageTitle: [PageTitleService, FiAppearanceStartPageEditStateResolePageTitle],
    },
};

export function FiAppearanceResolve_SiteDesignIdFn(
    stateService: FiStateService,
    tr: Transition,
    userDataService: FiUserDataService,
) {
    let siteDesignIdParam = stateService.getParams(tr).siteDesignId;
    return isDefined(siteDesignIdParam)
        ? coerceNumberProperty(siteDesignIdParam)
        : userDataService.getActiveSiteDesignId();
}

export function FiAppearanceStartPageEditStateResolveWidgets(widgetService: WidgetService) {
    return widgetService.getWidgets(ObjectTypes.FirstPage, {
        isEditMode: true,
    });
}

export function FiAppearanceStartPageEditStateResolveWidgetAdministrate(
    widgets: WidgetModel[],
    siteDesignId: number,
    widgetAdministrateService: WidgetAdministrateService,
) {
    const promise = widgetAdministrateService.getWidgetAdministrateForModule(ModuleType.FirstPage, {
        isEditMode: true,
        siteDesignId: siteDesignId,
    });
    promise.then((widgetAdministrate) => {
        if (!widgetAdministrate.BaseUrl) {
            widgetAdministrateService.InitAdministrateWidgetDefaultLayout(widgetAdministrate, widgets);
        }
    });
    return promise;
}

export function FiAppearanceStartPageEditStateResoleWidgetAdministrateWidgets(
    Widgets,
    WidgetAdministrate,
    WidgetAdministrateService,
) {
    return WidgetAdministrateService.BuildWidgetAdministrateWidgetsList(WidgetAdministrate, Widgets);
}

export function FiAppearanceStartPageEditStateResoleEditStartPageModel(fiUserDataService: FiUserDataService) {
    return {
        Layout: {
            SelectedControl: null,
        },
        ShowTrashBin: false,
        selectedLanguage: {
            id: fiUserDataService.userData.PreferredContentLanguage,
        },
        ControlContent: {
            ShowAllLanguages: false,
        },
    };
}

export function FiAppearanceStartPageEditStateResolePageTitle(ccmPageTitle) {
    return ccmPageTitle.setTitleByTextId('common.appearance');
}
